module.exports = __webpack_public_path__ + "img/paihang1.9a34da28.png";